import { Component } from '@angular/core';
import { CompanyCode } from '@shared/enums/company-code';
import { ViewHandlerComponent } from '@shared/view-handler/view-handler.component';
import {
  BrandedForgotPasswordComponent
} from '../branded-forgot-password/branded-forgot-password.component';
import { ForgotPasswordComponent } from '../forgot-password.component';

@Component({
  selector: 'zbp-forgot-password-handler',
  template: '<ng-container *ngComponentOutlet="componentToUse | async"></ng-container>',
  standalone: false
})
export class ForgotPasswordHandlerComponent extends ViewHandlerComponent {
  componentMap = {
    [CompanyCode.HighlightsPortal]: {
      component: BrandedForgotPasswordComponent,
    },
    [CompanyCode.ZBPortal]: {
      component: ForgotPasswordComponent,
    },
    ZbRedesign: {
      component: BrandedForgotPasswordComponent,
    }
  };
}
